module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b663fc3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitle.vue
// module id = 77
// module chunks = 0